<template>
  <div id="app" class="vh-100">
    <div class="d-flex flex-column vh-100">
      <header>
        <b-navbar toggleable="sm" type="dark" variant="dark">
          <b-navbar-nav class="ml-left">
            <b-nav-item v-bind:active="$route.name === 'home'" href="/">
              {{ $t("navHome") }}
            </b-nav-item>
            <b-nav-item style="font-weight:500;" v-bind:active="$route.name === 'analysis'" href="/analysis">{{
              $t("navAnalysis") }}</b-nav-item>
            <!-- <b-nav-item
              style="font-weight:500;"
              v-bind:active="$route.name === 'latest'"
              href="/latest"
              >{{ $t("Latest FRBs") }}</b-nav-item
            > -->
            <b-nav-item style="font-weight:500;" v-bind:active="$route.name === 'catalog'" href="/catalog">{{
              $t("navCatalog") }}</b-nav-item>
            <b-nav-item style="font-weight:500;" v-bind:active="$route.name === 'repeater_catalog'"
              href="/repeater_catalog">{{ $t("navRepeaterCatalog") }}</b-nav-item>
            <b-nav-item style="font-weight:500;" v-bind:active="$route.name === 'baseband-catalog-1'"
              href="/baseband-catalog-1">{{ $t("navBaseCat1") }}</b-nav-item>
            <b-nav-item style="font-weight:500;" v-bind:active="$route.name === 'voevent_info'" href="/voevents">{{
              $t("navVoeventInfo") }}</b-nav-item>
            <b-nav-item style="font-weight:500;" v-bind:active="$route.name === 'repeaters'" href="/repeaters">{{
              $t("navRepeaters") }}</b-nav-item>
            <b-nav-item style="font-weight:500;" v-bind:active="$route.name === 'galactic'" href="/galactic">{{
              $t("navGalactic") }}</b-nav-item>
            <b-nav-item style="font-weight:500;" v-bind:active="$route.name === 'Transit Calculator'"
              href="/astronomytools">{{ $t("navAstronomyTools") }}</b-nav-item>
            <b-nav-item style="font-weight:500;" href="https://chime-experiment.ca/" target="_blank">CHIME
              Experiment</b-nav-item>
          </b-navbar-nav>
        </b-navbar>
        <div class="chime-frb-banner">
          <h2 class="display-4">CHIME/FRB</h2>
          <h3 class="display-5 font-italic">Fast Radio Bursts in realtime</h3>
        </div>
      </header>

      <router-view class="flex-grow-1" />
      <footer class="bg-dark d-flex justify-content-center">  
        <p class="p-0 my-2 my-auto">© 2016-{{ currentYear }} CHIME/FRB Collaboration</p>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #343A40;
  margin-top: 0px;
}

footer {
  height: 50px;
  color: #fff;
}

header {
  text-align: left;
  color: #fff;
}

.chime-frb-banner {
  position: relative;
  display: flex;
  flex-direction: column;
  text-align: left;
  align-items: left;
  justify-content: left;
  background-image: url(./assets/banner_s.jpg);
  background-size: cover;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 1.5rem;
  color: #fff;
}

.chime-frb-banner::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1;
}

.chime-frb-banner h2,
.chime-frb-banner h3 {
  position: relative;
  z-index: 2;
}

.logo {
  height: 30px;
}

body {
  min-height: 100vh;
}
</style>
